import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { TriangleAlert } from 'lucide-react'

import styles from './styles.module.scss'

import { rejoinEnterprise } from '@/api/enterprise'
import wisprLogo from '@/assets/images/wisprLogo.svg?url'
import Button from '@/components/Button'
import { useToast } from '@/components/Toast/ToastContext'
import { AppDispatch } from '@/store'
import { getEnterpriseThunk } from '@/store/features/user/userSlice'

export default function RejoinTeam() {
  const dispatch = useDispatch<AppDispatch>()
  const { updateToast } = useToast()
  const [isLoading, setIsLoading] = useState(false)

  const handleRejoin = async () => {
    if (isLoading) return

    setIsLoading(true)
    try {
      const result = await rejoinEnterprise()
      if (result?.data) {
        await dispatch(getEnterpriseThunk({ needSubscription: false }))
        updateToast('Successfully rejoined the team!', 'success')
        // Redirect will happen automatically via AuthCheck
      } else {
        updateToast('Failed to rejoin team. Please try again or contact support.', 'error')
      }
    } catch (error) {
      console.error('Error rejoining team:', error)
      updateToast('Failed to rejoin team. Please try again or contact support.', 'error')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <div className={styles.warningBanner}>
        <TriangleAlert aria-hidden />
        <span>
          You already exhausted your team trial. You have 24 hours to add billing information to your team after
          rejoining before getting removed from the team.
        </span>
      </div>
      <div className={styles.createOrgContainer}>
        <img src={wisprLogo} alt="Wispr" className={styles.logo} />
        <h5>Rejoin your team</h5>
        <div className={styles.information}>You were previously a member of a Flow team. Click below to rejoin.</div>
        <div className={styles.createOrgForm}>
          <div className={styles.createOrgFormRow}>
            <Button
              title="Rejoin team"
              width={200}
              onClick={handleRejoin}
              isLoading={isLoading}
              isDisabled={isLoading}
              type="dark"
            />
          </div>
        </div>
      </div>
    </>
  )
}
